import { CommonModule } from '@angular/common';
import { Component, computed, forwardRef, input, linkedSignal, numberAttribute, output } from '@angular/core';
import { type ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';

@Component({
  selector: 'dpqa-checkbox',
  imports: [CommonModule, NzCheckboxModule, FormsModule],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.less',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor {
  // eslint-disable-next-line no-empty-function
  private onChange: (value: boolean) => void = () => { };
  // eslint-disable-next-line no-empty-function
  private onTouched: () => void = () => { };

  checked = input<boolean>(false);
  public value = linkedSignal(() => this.checked());

  indeterminate = input<boolean>(false);
  disabled = input<boolean>(false);

  fontSizeInput = input(1.6, { transform: numberAttribute, alias: 'fontSize' });
  fontSize = computed(() => `${this.fontSizeInput()}rem`);
  fontWeight = input(600, { transform: numberAttribute });

  lineHeightInput = input(1.6, { alias: 'lineHeight', transform: numberAttribute });
  lineHeight = computed(() => `${this.lineHeightInput()}rem`);

  gapInput = input(0.8, { alias: 'gap', transform: numberAttribute });
  gap = computed(() => `${this.gapInput()}rem`);

  checkedChanged = output<boolean>();

  writeValue(value: boolean): void {
    this.value.set(value);
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onCheckboxChange(event: boolean): void {
    if (!this.disabled()) {
      this.value.set(event);
      this.onChange(event);
      this.checkedChanged.emit(event);
    }
  }

  onCheckboxTouched(): void {
    this.onTouched();
  }
}
